module.exports = __webpack_public_path__ + "img/front cover 1.7.bc831d3b.jpg";